export default __webpack_public_path__ + "static/refer-property-banner-ae5038871f387d63b9ec661a5d602b04.png";